<template>
    <form :action="`/checkout/${selectedExistingPaymentMethod}`" method="POST" ref="form">
        <input type="hidden" name="_token" :value="csrf" />
    </form>
</template>

<script>
export default {
    mounted() {
        this.csrf = window.meta.csrf;
    },
    data: () => ({
        csrf: null
    }),
    props: {
        selectedExistingPaymentMethod: String
    },
    methods: {
        submit() {
            this.$refs.form.submit();
        }
    }
};
</script>
